module.exports = __webpack_public_path__ + "static/media/question.ee8f78a7.svg";